// src/directives/directives.module.ts
import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DisableLinkDirective } from './disable-link';
import { fullHeightDirective } from './fullHeight';

@NgModule({
  declarations: [
    DisableLinkDirective,
    fullHeightDirective
  ],
  imports: [
    IonicModule
  ],
  exports: [
    DisableLinkDirective,
    fullHeightDirective
  ]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts